import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Utils} from "../../../utils";

export interface StepDialog {
  title: string;
  description: string;
  seeks: {
    seekStart?: number;
    seekEnd?: number;
  }
  remove: boolean;
  isNew: boolean;
}

@Component({
  selector: 'app-new-step-dialog',
  templateUrl: './new-step-dialog.component.html',
  styleUrls: ['./new-step-dialog.component.scss']
})
export class NewStepDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<NewStepDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: StepDialog) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  remove() {
    this.data.remove = true;
    this.dialogRef.close(this.data);
  }

  ngOnInit(): void {
  }

  getStepDuration(): number {
    return Math.round(this.data.seeks.seekEnd - this.data.seeks.seekStart);
  }

  Utils() {
    return Utils;
  }

}
